import LayoutV5 from '@/components/layouts/LayoutV5';
import NotFoundContent from '@/components/notFound/NotFoundContent';

const NotFoundPage = () => {
    return (
        <>
            <LayoutV5>
                <NotFoundContent />
            </LayoutV5>
        </>
    );
};

export default NotFoundPage;